
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sell-on-pietra/register",
      function () {
        return require("private-next-pages/sell-on-pietra/register/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sell-on-pietra/register"])
      });
    }
  